import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ROUTES } from './routes/models.routes';
import { HeaderVista } from './components';
import Footer from './components/molecules/Footer';
import './App.css'
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    if (window.location.hostname === 'www.sudamericanaseguros.com.ar') {
      window.location.replace('https://www.aseguramas.com.ar' + window.location.pathname);
    }
  }, []);

  if (window.location.hostname === 'www.sudamericanaseguros.com.ar') {
    return null;
  }

  return (
    <div className='app-container'>
      <HeaderVista />
      <BrowserRouter>
        <Routes>
          {ROUTES.map((route, index) => (
            <Route key={index} path={route.path} element={<route.component />} />
          ))}
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

export default App;
